/**
 * @module builder
 */
import type { OptionsDocument } from 'paintscout'
import type { QuoteTemplateOption } from '../../index'
import get from 'lodash/get'

export function updateQuoteTemplateOption(args: {
  quoteTemplateOption: QuoteTemplateOption
  options: OptionsDocument
}): OptionsDocument {
  const { options, quoteTemplateOption } = args

  const order = [...get(options, 'options.quoteTemplates.order', [])]
  const orderIndex = order.indexOf(quoteTemplateOption.key)
  if (orderIndex === -1) {
    order.push(quoteTemplateOption.key)
  }

  const values = get(options, 'options.quoteTemplates.values', {})

  return {
    ...options,
    options: {
      ...options.options,
      quoteTemplates: {
        ...options.options.quoteTemplates,
        values: {
          ...values,
          [quoteTemplateOption.key]: {
            active: true,
            ...values[quoteTemplateOption.key],
            ...quoteTemplateOption
          }
        },
        order
      }
    }
  }
}
